import { HttpErrorResponse } from "@angular/common/http";
import { AfterViewInit, Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import notify from "devextreme/ui/notify";
import {
    IOcbEnvironmentLog,
    OcbEnvironmentLogTypes,
    EnvironmentsService,
    UserService
} from "../../core";

@Component({
    selector: 'app-environment-log',
    templateUrl: './environment-log-popup.component.html',
    styleUrls: ['./environment-log-popup.component.scss']
})
export class EnvironmentLogComponent implements AfterViewInit {
    @Input() public log?: IOcbEnvironmentLog;
    @Input() public logId?: string;

    public visible: boolean = false;

    private displayedLog?: IOcbEnvironmentLog;
    private isProgressBarVisible: boolean = false;
    private logsTypesLabels: any[];

    constructor(private logsService: EnvironmentsService, private translateService: TranslateService, private userService: UserService) {
        this.displayLogDate = this.displayLogDate.bind(this);
        this.displayLogType = this.displayLogType.bind(this);
    }

    public ngAfterViewInit() {
        this.translateService.get('environmentLogTypes').subscribe(logTypes => {
            this.logsTypesLabels = logTypes;
        });
    }

    public onHidden() { this.displayedLog = null; }

    public onShown() {
        if (this.log) this.displayedLog = this.log;
        else if (this.logId) {
            this.isProgressBarVisible = true;
            this.logsService.getLog(this.logId).subscribe({
                next: (log) => {
                    this.displayedLog = log;
                    this.isProgressBarVisible = false;
                },
                error: (err) => this.handleError(err)
            });
        }
        else this.isProgressBarVisible = false;
    }


    public displayLogDate(log): string { return log?.logDate ? this.displayDate(log.logDate).toLocaleString(this.getCurrentLocale()) : ''; }

    public displayLogType(log): string { return log?.logType ? this.logsTypesLabels[OcbEnvironmentLogTypes[log.logType]] : ''; }


    private displayDate(dateValue): Date { return new Date(dateValue + 'Z'); }

    private handleError(error: any): void {
        let message: '';
        if (error instanceof HttpErrorResponse) {
            if (error.error.hasOwnProperty('message')) {
                message = error.error.message;
            } else if (error.error.hasOwnProperty('name')) {
                message = error.error.name;
            } else {
                message = error.error;
            }
        } else {
            message = error;
        }

        notify(message, 'error', 3000);
    }

    private getCurrentLocale(): string {
        let currentLocale = 'en-US';
        switch (this.userService.language) {
            case 'en': currentLocale = 'en-US'; break;
            case 'fr': currentLocale = 'fr-FR'; break;
        }
        return currentLocale;
    }
}
